import React, { useContext } from 'react';
import TableCell from '@mui/material/TableCell';
import TableContext from './table-context';
import './GenericTable.scss';
import { formatDateTimeToDate } from '../../../shared/utility';

const Cell = props => {
  const ctx = useContext(TableContext);

  const renderCellText = () => {
    const params = {
      rowId: props.row.id,
      currentRow: props.row,
      currentColumnName: props.column.name,
      colType: props.column.type,
      availableColumnValues: props.column.availableColumnValues,
    };
    const resultObj = ctx.setColTypeAndEditingState(params);

    if (!!resultObj.availableColumnValues) {
      let foundSelectedValue = resultObj.availableColumnValues.find(
        obj => obj.value === props.value
      );
      if (foundSelectedValue) return foundSelectedValue.display;
    }

    if (props.column.formatToDate) {
      return formatDateTimeToDate(props.value);
    }

    if (typeof props.value === 'string') return props.value;

    if (Array.isArray(props.value)) {
      const foundSelectedValue = props.value.find(
        optionObj => !!optionObj.isDefault
      );
      if (foundSelectedValue) return foundSelectedValue.display;
      return null;
    }

    return props.value;
  };

  return <TableCell>{renderCellText()}</TableCell>;
};

export default Cell;
